import { Controller } from '@hotwired/stimulus';
import { watch } from '@vue/reactivity';

export default class extends Controller {
  static targets = ['output'];

  connect() {
    requestAnimationFrame(() => {
      const elements = Array.from(document.querySelectorAll('[data-reactive-value]'));
      const refs = elements.map((element) => element.reactiveValue);
      watch(
        refs,
        (newRefs) => this.outputTarget.innerHTML = newRefs.reduce((acc, ref) => acc + ref, 0),
        { immediate: true },
      );
    });
  }
}
